export default [{
  name: 'finanfast',
  namespaced: true,
  state: {},
  mutations: {},
  getters: {},
  actions: {}
}]
